// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'neueMontreal', 'neueMontreal Fallback'"},"className":"__className_7419b6","variable":"__variable_7419b6"};